import { Component } from 'react';
import { Mensajes } from './Mensajes';
import { AlertModal } from './AlertModal';
import { Sedes } from './Sedes';
import { SedeMedicoPersonal } from './sedeMedicoPersonal';

export class MiMedicoPersonal extends Component {
  constructor() {
    super();
    this.state = {
      configurations: {},
      isAuthenticatedBoolean: false,
      options: {
        loadingAuthUser: false,
      },
      userInfo: {},
      currentComponentToRender: false,
      currentAlert: ''
    }
    this.plan = document.getElementById('app').getAttribute('plan');
    //CE => PC
    //EP => PBS
    this.pnpService = new ServicioPnp();
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.onClickAgreeButton = this.onClickAgreeButton.bind(this);

    this.tools = new Tools();
  }
   
  loadApiKey() {
    const ApiKey = this.state.configurations.ApiKey;
    if(!ApiKey) {
      setTimeout(() => this.loadApiKey(), 200);
      return;
    }
    const filename = `https://maps.googleapis.com/maps/api/js?key=${ApiKey}`;
    const file = document.createElement('script');
    file.setAttribute('type', 'text/javascript');
    file.setAttribute('src', filename);
    document.getElementsByTagName("head")[0].appendChild(file)
  }
 
  componentDidMount() {
    const configurations = {};

    this.pnpService.getListWithTop('configuraciones', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote;
      });
      this.setState({ configurations: configurations }, this.loadApiKey);
    }, 200, "CSNombreText eq 'MensajeErrorDeServicios' or CSNombreText eq 'MensajeNegacionDeServicio' or CSNombreText eq 'MensajeErrorServicioBeneficiarios' or CSNombreText eq 'FBA_CLAIM' or CSNombreText eq 'ApiKey'", 'CSNombreText', 'CSValorNote');

    this.pnpService.getListWithTop('parametrosPaginas', (list) => {
      list.forEach((item) => {
        configurations[item.CSNombreText] = item.CSValorNote == 'false' ? false : item.CSValorNote;
        configurations[item.CSNombreText + 'CSVisibleBool'] = item.CSVisibleBool;
      });
      this.setState({ configurations: configurations });
    }, 200, (this.plan == 'EP' ?
        "CSFormularioChoice eq 'Home PBS' or CSFormularioChoice eq 'Mi Red de Atenci%C3%B3n' or CSFormularioChoice eq 'PBS RA Mi Sede y M%C3%A9dico Personal'"
      :
        "CSFormularioChoice eq 'Home PC' or CSFormularioChoice eq 'Mi Red de Atenci%C3%B3n' or CSFormularioChoice eq 'PC RA Mi M%C3%A9dico Personal'"
        )
      );

    setTimeout(() => { this.isAuthenticated() }, 500);
  }

  onClickAgreeButton(){
    this.setState({ currentAlert: '' });
    //window.location.href = _spPageContextInfo.webAbsoluteUrl ;
    window.history.back();
  }

  isAuthenticated() {
    if (!compTools.autenticadoWindows() && compTools.estaAutenticado()) {
      const authenticatedUser = compTools.obtenerInformacionUsuario();
      if(authenticatedUser['LegalID'] && authenticatedUser['TipoIdentificacion']){
        const options = JSON.parse(JSON.stringify(this.state.options));
        options.loadingAuthUser = true;
        this.setState({ isAuthenticatedBoolean: true, userInfo: authenticatedUser, options: options });
        if(authenticatedUser['ValidacionDerechos'] && authenticatedUser.Error.CodigoStatusError === null){
          
          const validarDerechosCliente =  authenticatedUser['ValidacionDerechos'];
          const allowed = validarDerechosCliente && validarDerechosCliente.DerechoPrestacion && validarDerechosCliente.DerechoPrestacion === 'SI' && this.plan === validarDerechosCliente.Programa ? true : false;
          if(allowed){
            this.setState({ currentComponentToRender: true });
          }else{
            if(validarDerechosCliente && validarDerechosCliente.Programa !== 'EP' && validarDerechosCliente.Programa !== 'CE') {
              this.setState({ currentAlert: 'alertModal', usuarioCaja: true})
            } else if(validarDerechosCliente && validarDerechosCliente.DerechoPrestacion && validarDerechosCliente.DerechoPrestacion === 'NO'){
              this.setState({ currentAlert: 'alertModal' });
            }else if(this.plan !== validarDerechosCliente.Programa){
              this.setState({ currentAlert: 'alertModal'  });
            }else {
              this.setState({ currentAlert: 'messages' });
            }
          }
        }else{
         
          this.setState({ currentAlert: 'messages' });
        }
      }else{
        this.setState({ currentAlert: 'messages' });
      }
    } else {
      this.setState({ currentComponentToRender: false });
    }
  }

  getLoginURL(param) {
    if (param) {
      const splitParam = param.split('|');

      return location.protocol == 'https:' ? (window.location.origin + '/_trust/default.aspx?trust=' + splitParam[1] + '&ReturnUrl=' + window.location.pathname) : (window.location.origin + '/_layouts/15/Authenticate.aspx?Source=' + document.location.href);
    } else {
      return '';
    }
  }

  render() {
    let loginURL = '';
    
    if(Object.keys(this.state.configurations).length) {
      loginURL = this.getLoginURL(this.state.configurations['FBA_CLAIM']);
    }
    return (
      <div>
       <div>
       { this.state.currentAlert === 'alertModal' ? 
          <AlertModal message={this.state.configurations[this.state.usuarioCaja? 'MensajeNegacionUsuarioCaja':'MensajeNegacionDeServicio']} onClickAgreeButton={ () => this.onClickAgreeButton() } />
        : null}
        { this.state.currentAlert === 'messages' ? 
        <Mensajes msg={this.state.configurations['MensajeErrorDeServicios']} /> : 
        null }
        </div>
        <div className="medical-network-info">
          <div className="row">
            <div className="col-sm-12">
              <h2 className="title">{this.state.configurations[(this.plan == 'EP' ? 'MiSedeMedicoPersonalTitulo' : 'MiMedicoPersonalTitulo')]}</h2>
              <p dangerouslySetInnerHTML={{__html: this.state.configurations[(this.plan == 'EP' ? 'MiSedeMedicoPersonalTextoIntroductorio' : 'MiMedicoPersonalTextoIntroductorio')]}}></p>
            </div>
          </div>
          { !this.state.isAuthenticatedBoolean ? (
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="login-box">
                    <h2>RECIBE TU INFORMACIÓN PERSONALIZADA</h2>
                    <p>Para recibir tu información personalizada es necesario que ingreses con tu usuario Compensar, asì te podremos mostrar la información personalizada para ti y de tu familia</p>
                    <div className="text-center"><a className="btn btn-primary" href={loginURL}>Iniciar Sesión</a></div>
                  </div>
                </div>
              </div>
              <Sedes configurations={this.state.configurations} plan={this.plan} />
            </div>) : '' }
        </div>
        <div className="medical-container">
          { this.state.currentComponentToRender ? 
            <SedeMedicoPersonal configurations={this.state.configurations} userInfo={this.state.userInfo} typeUser={this.plan}  />
            : 
            null
          }
        </div>
      </div>
    );
  }
}
